import React, { memo } from 'react';
import { equals } from 'ramda';
import clsx from 'clsx';
import { Tooltip } from '@mui/material';

import palette from '../../styles/palette';
import { SpotIcon } from '../../icons';

import {
  HIGH_VALUE_PARCEL,
  PHARMA_PARCEL,
  TOTE_PARCEL,
} from '../../../constants/strings';
import { getManifestValue } from '../../../models/stop';
import { Text } from '../../Base';
import { ConditionalWrapper } from '../../ConditionalWrapper';

// eslint-disable-next-line react/display-name
export const ServiceItem = memo(
  ({ value }) => {
    const color =
      (!!value?.perishable && palette.statuses.statusBlue) ||
      (!!value?.vipDelivery && palette.dpdRed);

    return (
      <span>
        {color && <SpotIcon color={color} />} {value?.serviceLabel}
      </span>
    );
  },
  (prevProps, nextProps) => equals(prevProps.value, nextProps.value)
);

const Item = ({ classes }) => <div className={clsx(classes)}></div>;

// eslint-disable-next-line react/display-name
export const HighValueItem = memo(
  ({ rowData, classes }) => {
    const { highValue, smallsToteParcel, pharma } = rowData;
    let values = [];
    let tipItems = [];

    if (smallsToteParcel) {
      values.push(
        <Item classes={[classes.cellHighValue, classes.cellOrange]} />
      );
      tipItems.push(TOTE_PARCEL);
    }

    if (highValue) {
      values.push(<Item classes={[classes.cellHighValue, classes.cellBlue]} />);
      tipItems.push(HIGH_VALUE_PARCEL);
    }

    if (pharma) {
      values.push(
        <Item classes={[classes.cellHighValue, classes.cellGreen]} />
      );
      tipItems.push(PHARMA_PARCEL);
    }

    return values.length ? (
      <Tooltip
        title={
          <div style={{ whiteSpace: 'pre-line' }}>{tipItems.join('\n')}</div>
        }
        placement="right-start"
        fontSize="small"
      >
        <div className={clsx([classes.fullHeighContainer])}>{values}</div>
      </Tooltip>
    ) : (
      ''
    );
  },
  (prevProps, nextProps) => equals(prevProps.rowData, nextProps.rowData)
);

const ManifestLocationItemComponent = ({
  value,
  classes,
  maxCellValueWidth,
}) => {
  if (!value) {
    return null;
  }
  const valuesArr = Array.isArray(value) ? value : [value];
  const displayValue = getManifestValue(valuesArr);
  return (
    <ConditionalWrapper
      condition={
        !!valuesArr.length &&
        (valuesArr.length > 2 || displayValue.length > maxCellValueWidth)
      }
      wrapper={(children) => (
        <Tooltip
          placement="bottom-start"
          PopperProps={{
            popperOptions: {
              modifiers: {
                offset: {
                  enabled: true,
                  offset: '0, -10',
                },
              },
            },
          }}
          fontSize="small"
          title={
            <div style={{ whiteSpace: 'pre-line' }}>{valuesArr.join(', ')}</div>
          }
        >
          {children}
        </Tooltip>
      )}
    >
      <div className={clsx([classes.container])}>
        <Text
          noWrap
          className={clsx([classes.cellText, classes.cellCroppedText])}
        >
          {displayValue}
        </Text>
      </div>
    </ConditionalWrapper>
  );
};

export const ManifestLocationItem = memo(
  ManifestLocationItemComponent,
  (prevProps, nextProps) => equals(prevProps.value, nextProps.value)
);
ManifestLocationItem.displayName = 'ManifestLocationItem';
